import { queryString, } from 'utils/window';
import { path, } from 'utils/ua';
import { reduceObjectEntries, } from 'utils/object';
import actionCounterProviderActions from 'actions/actionCounterProviderActions';
import { warn, } from 'application/console';


const { readsCounter: shouldDisplayPostStatsInEmbedLayout } = queryString;
const { DATA_RECEIVED, RECEIVED_ERROR, } = actionCounterProviderActions.TYPES;
const STATS = ['reads', 'comments', 'shares'];
const FILTER_STATS = ['reads'];


function toNumber(string) {
  return parseInt(string, 10);
}

function getQueryStringKey(key) {
  return toNumber(queryString[key]);
}

function isOverride(queryStringStats){
  return !STATS.some(statName => !(statName in queryStringStats));
}

function mapAllKeysFromQuery(key) {
  return { [key]: getQueryStringKey(key) || 0, };
}

function mapExistingKeysFromQuery(key) {
  const queryStringKey = getQueryStringKey(key);
  return queryStringKey ? { [key]: queryStringKey, } : '';
}

function mapReduceArrayToObject(stats, fn) {
  return stats
    .map(fn)
    .reduce((acc, statObj) => {
      return { ...acc, ...statObj, };
    }, {});
}

function getStatsFromDebugQuery(mapFn) {
  return mapReduceArrayToObject(STATS, mapFn);
}

function parseObjectValuesOrZero(parsedObject, [key, value]) {
  return { ...parsedObject, [key]: toNumber(value) || 0, };
}

function removeZeroValuesFromObject(zeroLessObject, [key, value]) {
  const newKey = value > 0 ? { [key]: value, } : {};
  return { ...zeroLessObject, ...newKey, };
}

function queryStatsReducer(filterStats, statsObject) {
  return filterStats.reduce(function(filteredStats, stat) {
    const isUnvalidStat = stat === undefined;
    const validStat = isUnvalidStat ? {} : { [stat]: statsObject[stat], };
    return { ...filteredStats, ...validStat, };
  }, {});
}

const parseObjectValues = reduceObjectEntries.part(parseObjectValuesOrZero);
const removeZeroValuePropertiesFromObject = reduceObjectEntries.part(removeZeroValuesFromObject);

function filterStatsByQueryStringOrAll(isStatsInQuery, filterStats) {
  return originalStats => {
    return isStatsInQuery ?
      parseObjectValues(queryStatsReducer(filterStats, originalStats)) :
      removeZeroValuePropertiesFromObject(parseObjectValues(originalStats));
  };
}

const getFilteredStats = filterStatsByQueryStringOrAll(shouldDisplayPostStatsInEmbedLayout, FILTER_STATS);

function setReceivedState(state, action) {
  const { reads, comments, shares, } = action.state;
  return {
    stats: {
      ...getFilteredStats({ reads, comments, shares, }),
      ...getStatsFromDebugQuery(mapExistingKeysFromQuery),
    },
  };
}

function setState(state, newState) {
  return { ...state, ...newState, };
}

function recievedData(state, action) {
  if (state.IS_DRAFT) {
    return setState(state, getStatsFromDebugQuery(mapAllKeysFromQuery));
  }
  if (!state.IS_OVERRIDE) {
    return setState(state, setReceivedState(state, action));
  }
}

function recievedError(state, action) {
  const { error } = action.state;
  warn('Error recieving data from external source, check with provier', { error, action, });
  return setState(state, getStatsFromDebugQuery(mapAllKeysFromQuery));
}

const INITIAL_STATE =  {
  stats: {},
  IS_OVERRIDE: isOverride(getStatsFromDebugQuery(mapExistingKeysFromQuery)),
  IS_DRAFT: path.isDraft,
};

export function postMetadataReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case DATA_RECEIVED:
      return recievedData(state, action);
    case RECEIVED_ERROR:
      return recievedError(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/post_metadata/postMetadataReducer.js